import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "./Css/Contact.css";

const Contact = () => {

  const form = useRef();

const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm(
    "service_44rwqle",
    "template_u0fgfjc",
    form.current,
    "yXgYIvgQ5MrWLCzmK"
  )
  .then((result) => {
      console.log("SUCCESS!", result.text);
      alert("Message Sent Successfully ✅");
  })
  .catch((error) => {
      console.log("FULL ERROR:", error);
      alert("Error: " + error.text);
  });

  e.target.reset();
};

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1 className="contact-title">Contact AKES Software</h1>

        <div className="contact-content">

          <div className="contact-info">
            <h2>AKES Software</h2>
            <p><strong>Email:</strong> akessoftware@gmail.com</p>
            <p><strong>Phone:</strong> 9890600278, 9922553901</p>
            <p><strong>Location:</strong> Maharashtra, India</p>
          </div>

          <div className="contact-form">
            <h3>Send us a Message</h3>

            <form ref={form} onSubmit={sendEmail}>
              <input type="text" name="user_name" placeholder="Your Name" required />
              <input type="email" name="user_email" placeholder="Your Email" required />
              <textarea name="message" placeholder="Your Message" rows="5" required></textarea>
              <button type="submit">Send Message</button>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;